module.exports = __webpack_public_path__ + "static/media/Mobile_Carrosel_e_Workshop_DESENVOLVIMENTO_APLICACOES_MOVEIS.fc64ee68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/aplicMoveis/Mobile_Carrosel_e_Workshop_DESENVOLVIMENTO_APLICACOES_MOVEIS.png
// module id = 10
// module chunks = 0